import C from 'classnames';
import React from 'react';

interface IRadioButtonProps {
  checked?: boolean;
  name?: string;
  variant?: string;
  size?: string;
  rounded?: boolean;
  outline?: boolean;
  active?: boolean;
  disabled?: boolean;
  block?: boolean;
  className?: string;
  onClick?: (e?: React.MouseEvent<HTMLInputElement>) => void;
  children?: React.ReactNode;
}

const sizeMapper: { [index: string]: string } = {
  lg: 'btn-lg',
  sm: 'btn-sm',
};

const variantMapper = (
  outline: boolean | undefined
): { [index: string]: string } => {
  if (outline) {
    return {
      primary: 'btn-outline-primary',
      secondary: 'btn-outline-secondary',
      success: 'btn-outline-success',
      info: 'btn-outline-info',
      warning: 'btn-outline-warning',
      danger: 'btn-outline-danger',
      light: 'btn-outline-light',
      dark: 'btn-outline-dark',
      white: 'btn-outline-white',
    };
  } else {
    return {
      primary: 'btn-primary',
      secondary: 'btn-secondary',
      success: 'btn-success',
      info: 'btn-info',
      warning: 'btn-warning',
      danger: 'btn-danger',
      light: 'btn-light',
      dark: 'btn-dark',
      white: 'btn-white',
    };
  }
};

export const RadioButton: React.FunctionComponent<IRadioButtonProps> = (
  props: IRadioButtonProps
) => {
  return (
    <label
      className={C(
        'btn',
        props.className,
        props.variant && variantMapper(props.outline)[props.variant],
        props.size && sizeMapper[props.size],
        props.rounded && 'btn-rounded-circle',
        props.active && 'active',
        props.disabled && 'disabled',
        props.block && 'btn-block',
        props.checked && 'active'
      )}
    >
      <input
        type="radio"
        name={props.name}
        checked={props.checked}
        onClick={props.onClick}
      />
      {props.children}
    </label>
  );
};
